import React from 'react';
import styled from 'styled-components';
import { device } from '../utils/devices';

const LogoBlock = styled.div`
  background: ${props => props.theme.bg}
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;

  svg {
    width: 20vw;
  }

  @media ${device.laptop} {
    width: auto;
    padding: 2vw;
    grid-row: 1/3;

    svg {
      width: auto;
    }
  }
`;

const Logo = (props) => {
  return (
    <LogoBlock>

<svg width="135px" height="116px" viewBox="0 0 135 116" version="1.1">
  <g id="Welcome" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Desktop-HD-Copy" transform="translate(-53.000000, -139.000000)" fill="#212121">
          <path d="M72.386,246.476 C72.386,251.948 67.706,254.72 63.026,254.72 C58.67,254.72 54.566,252.416 53.702,247.628 L56.258,246.548 C56.978,250.616 59.966,252.2 63.026,252.2 C66.266,252.2 69.506,250.22 69.506,246.692 C69.506,244.748 68.138,242.732 65.654,242.156 L59.786,240.824 C56.33,240.032 54.494,237.152 54.494,234.128 C54.494,228.872 58.67,226.28 62.954,226.28 C67.058,226.28 71.234,228.692 71.81,233.444 L69.362,234.416 C68.534,230.42 65.834,228.836 62.81,228.836 C59.138,228.836 57.374,231.464 57.374,233.948 C57.374,235.892 58.562,237.728 60.614,238.232 L66.95,239.672 C70.478,240.5 72.386,243.38 72.386,246.476 Z M94.058,227 L94.058,229.52 L86.102,229.52 L86.102,254 L83.222,254 L83.222,229.52 L75.266,229.52 L75.266,227 L94.058,227 Z M118.538,227 L118.538,244.28 C118.538,250.04 113.858,254.72 108.098,254.72 C102.338,254.72 97.658,250.04 97.658,244.28 L97.658,227 L100.538,227 L100.538,244.28 C100.538,248.636 103.922,252.2 108.098,252.2 C112.274,252.2 115.658,248.636 115.658,244.28 L115.658,227 L118.538,227 Z M146.978,240.5 C146.978,247.952 140.93,254 133.478,254 L124.298,254 L124.298,227 L133.478,227 C140.93,227 146.978,233.048 146.978,240.5 Z M144.098,240.5 C144.098,234.452 139.166,229.52 133.118,229.52 L127.178,229.52 L127.178,251.48 L133.118,251.48 C139.166,251.48 144.098,246.548 144.098,240.5 Z M154.538,227 L154.538,254 L151.658,254 L151.658,227 L154.538,227 Z M187.658,240.5 C187.658,248.348 181.286,254.72 173.438,254.72 C165.59,254.72 159.218,248.348 159.218,240.5 C159.218,232.652 165.59,226.28 173.438,226.28 C181.286,226.28 187.658,232.652 187.658,240.5 Z M184.778,240.5 C184.778,234.056 179.702,228.8 173.438,228.8 C167.174,228.8 162.098,234.056 162.098,240.5 C162.098,246.944 167.174,252.2 173.438,252.2 C179.702,252.2 184.778,246.944 184.778,240.5 Z" id="STUDIO"></path>
          <path d="M85.612,158.944 L99.004,158.944 L79.996,202.072 C77.764,207.184 72.436,209.704 67.036,209.704 C64.372,209.704 61.636,208.984 59.332,207.616 L59.332,195.952 C60.484,196.744 63.364,197.824 65.74,197.824 C67.324,197.824 68.692,197.392 69.196,196.168 L72.292,189.256 L58.828,158.944 L72.22,158.944 L78.916,174.208 L85.612,158.944 Z M138.748,139 L138.748,193 L126.364,193 C124.348,193.864 122.188,194.152 119.812,194.152 C110.02,194.152 101.884,185.944 101.884,175.864 C101.884,165.856 110.02,157.648 119.812,157.648 C122.188,157.648 124.348,158.08 126.364,158.944 L126.364,139 L138.748,139 Z M126.364,175.864 C126.364,172.192 123.484,169.384 120.316,169.384 C117.148,169.384 114.268,172.12 114.268,175.864 C114.268,179.68 117.148,182.416 120.316,182.416 C123.484,182.416 126.364,179.608 126.364,175.864 Z M169.78,158.944 L183.172,158.944 L164.164,202.072 C161.932,207.184 156.604,209.704 151.204,209.704 C148.54,209.704 145.804,208.984 143.5,207.616 L143.5,195.952 C144.652,196.744 147.532,197.824 149.908,197.824 C151.492,197.824 152.86,197.392 153.364,196.168 L156.46,189.256 L142.996,158.944 L156.388,158.944 L163.084,174.208 L169.78,158.944 Z" id="ydy"></path>
      </g>
  </g>
</svg>
    </LogoBlock>
  )
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js